import 'util/Plaintext.Util';
import 'Spinner';

let isInitialized = false;

function init() {
  if (isInitialized) { return; }
  isInitialized = true;
  
  window.Plaintext.Spinner.enable('.resourceOrderForm__inputWrap input');
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('pageshow', init);

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  init();
}

